import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-left: -14px; /* keep alignment with possible clear button */\n  margin-right: -", "px; /* TextField adds extra padding on the right */\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { formatDate, setTimeToMidDay } from '@scp/ui-shared/core/utils';
import { InputCalendar } from '@scp/ui-shared/components/date-time/calendars';
import { Popover } from '@scp/ui-shared/components/popover';
import { WithOutsideClick } from '@scp/ui-shared/components/wrappers';
import { TextFieldWithMask } from './TextFieldWithMask';
import { TriggerButton } from './base';
import { FIELD_INNER_PADDING } from './constants';
export var DATE_MASK = '##/##/####';
var DATE_MASK_FORMAT = 'MM/DD/YYYY';
var TEXT = {
  TOGGLE_BUTTON: 'Toggle calendar'
};
var Wrapper = styled(WithOutsideClick)(_templateObject());
var ArrowButtonWrapper = styled.div(_templateObject2(), FIELD_INNER_PADDING / 2);

var dateToString = function dateToString(value) {
  return value ? formatDate(value, {
    format: 'dateInputMask'
  }) : '';
};

var stringToValidDate = function stringToValidDate(value) {
  var fallbackPartialToToday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  // Do not parse partialy entered values unless `fallbackPartialToToday` (for example 02/__/____)
  if (!fallbackPartialToToday && value.includes('_')) {
    return undefined;
  }

  var dateValue = moment(value, DATE_MASK_FORMAT);

  if (!dateValue.isValid()) {
    return undefined;
  }

  return setTimeToMidDay(dateValue.toDate());
};

var isValidInRange = function isValidInRange(date, minDate, maxDate) {
  if (minDate && moment(date).isBefore(moment(minDate).startOf('day'))) {
    return false;
  }

  if (maxDate && moment(date).isAfter(moment(maxDate).endOf('day'))) {
    return false;
  }

  return true;
};

export var DatePickerInputField = function DatePickerInputField(_a) {
  var minDate = _a.minDate,
      maxDate = _a.maxDate,
      value = _a.value,
      _a$onChange = _a.onChange,
      onChange = _a$onChange === void 0 ? function () {
    return null;
  } : _a$onChange,
      _a$onFocus = _a.onFocus,
      _onFocus = _a$onFocus === void 0 ? function () {
    return null;
  } : _a$onFocus,
      _a$onBlur = _a.onBlur,
      onBlur = _a$onBlur === void 0 ? function () {
    return null;
  } : _a$onBlur,
      _onClear = _a.onClear,
      clearable = _a.clearable,
      calendarHidden = _a.calendarHidden,
      defaultSelectedDay = _a.defaultSelectedDay,
      rest = __rest(_a, ["minDate", "maxDate", "value", "onChange", "onFocus", "onBlur", "onClear", "clearable", "calendarHidden", "defaultSelectedDay"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isCalendarOpen = _useState2[0],
      setCalendarOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      localStringValue = _useState4[0],
      setLocalStringValue = _useState4[1];

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      localValue = _useState6[0],
      setLocalValue = _useState6[1];

  useEffect(function () {
    // Update local state if it was changed from the top (controlled component)
    if (!value) {
      setLocalValue(undefined);
      setLocalStringValue('');
      return;
    }

    if (!moment(value).isSame(localValue)) {
      setLocalValue(value);
      setLocalStringValue(dateToString(value));
    }
  }, [localValue, value]);

  var updateDate = function updateDate(dateValue) {
    setLocalValue(dateValue);
    onChange(dateValue);
  };

  var closeAndBlur = function closeAndBlur() {
    onBlur();
    setCalendarOpen(false);
    var enteredDate = stringToValidDate(localStringValue); // If invalid value was entered, dismiss it on blur

    if (!enteredDate || !isValidInRange(enteredDate, minDate, maxDate)) {
      setLocalStringValue(dateToString(localValue));
    }
  };

  return React.createElement(Wrapper, {
    onClickOutside: function onClickOutside() {
      if (isCalendarOpen && !calendarHidden) closeAndBlur();
    }
  }, React.createElement(TextFieldWithMask, Object.assign({
    placeholder: DATE_MASK_FORMAT,
    truncate: true
  }, rest, {
    clearable: clearable && !isCalendarOpen,
    format: DATE_MASK,
    value: localStringValue,
    onClear: function onClear() {
      if (_onClear) {
        _onClear();

        return;
      }

      updateDate(undefined);
    },
    onChange: function onChange(_, values) {
      var stringValue = values.formattedValue;
      setLocalStringValue(stringValue);

      if (!stringValue && localValue) {
        updateDate(undefined);
        return;
      }

      var dateValue = stringToValidDate(stringValue);

      if (dateValue && isValidInRange(dateValue, minDate, maxDate)) {
        updateDate(dateValue);
      }
    },
    onFocus: function onFocus(e) {
      _onFocus(e);

      !calendarHidden && setCalendarOpen(true);
    },
    onBlur: function onBlur() {
      if (calendarHidden) closeAndBlur();
    },
    onClick: function onClick() {
      if (!isCalendarOpen && !calendarHidden) setCalendarOpen(true);
    },
    onKeyDown: function onKeyDown(e) {
      // Since on blur event is not used, it should be closed on outside click OR tab press
      if (e.key === 'Tab' && !calendarHidden) closeAndBlur();
    },
    infieldActions: !calendarHidden && React.createElement(ArrowButtonWrapper, null, React.createElement(TriggerButton, {
      "aria-label": TEXT.TOGGLE_BUTTON,
      tabIndex: -1,
      title: TEXT.TOGGLE_BUTTON,
      onClick: function onClick() {
        return setCalendarOpen(!isCalendarOpen);
      },
      iconName: "event-note"
    }))
  })), React.createElement(Popover, {
    open: isCalendarOpen,
    onClose: closeAndBlur,
    width: "auto",
    noTriangle: true
  }, React.createElement(InputCalendar, {
    selectedDay: stringToValidDate(localStringValue, true) || (localValue ? moment(localValue).toDate() : defaultSelectedDay || moment(localValue).toDate()),
    onSelectDay: function onSelectDay(date) {
      updateDate(date);
      setLocalStringValue(dateToString(date));
      setCalendarOpen(false);
    },
    minDate: minDate,
    maxDate: maxDate,
    showSelectedValue: false
  })));
};